<script setup lang="ts">
import { ActivityDetailsModalType } from '../models';
import {
  useActivityDetailsModalsStore,
  useActivityDetailsStore,
} from '../stores';

import TicketsSelectorModal from './ticketsSelector/TicketsSelectorModal.vue';
import FullDescriptionModal from './FullDescriptionModal.vue';

const activityDetailsModalsStore = useActivityDetailsModalsStore();
const activityDetailsStore = useActivityDetailsStore();

interface ActivityDetailsModals {
  (event: 'close-navigate'): void;
}
const emit = defineEmits<ActivityDetailsModals>();

function closeNavigate(): void {
  close();
  emit('close-navigate');
}

function close(): void {
  activityDetailsModalsStore.closeModal();
}
</script>

<template>
  <TicketsSelectorModal
    v-if="
      activityDetailsModalsStore.activityDetailsModalType ===
      ActivityDetailsModalType.TicketsSelection
    "
    @close="close"
    @close-navigate="closeNavigate"
  />

  <FullDescriptionModal
    v-if="
      activityDetailsModalsStore.activityDetailsModalType ===
      ActivityDetailsModalType.FullDescription
    "
    :main-description="activityDetailsStore.mainData.mainDescription"
    :activity-name="activityDetailsStore.mainData.activityName"
    @close-modal="activityDetailsModalsStore.closeModal"
  />
</template>
